// 板発注の 48 コマリボン (横スクロール) で、 選択中のコマを見える位置に出すための
// スクロール量 (issue #10107)。 保持したコマを復元した時に、 選択中の chip がスクロールの
// 外に隠れたままにならないようにする。

type Params = {
  /** chip の左端 (スクロール内容の先頭からの距離, px)。 */
  chipLeft: number
  chipWidth: number
  /** 現在のスクロール位置 (scrollLeft, px)。 */
  scrollLeft: number
  /** スクロール領域の見えている幅 (clientWidth, px)。 */
  viewWidth: number
}

/**
 * chip が見えている範囲に収まっていれば `undefined` (= スクロールしない。 クリックで
 * 選んだ時にリボンが動かないため)。 はみ出していれば chip を中央に置く scrollLeft を返す
 * (共通 ribbon [[KomaRibbon]] の現在コマへの自動スクロールと同じ中央寄せ)。
 */
export function ribbonScrollLeftToReveal({
  chipLeft,
  chipWidth,
  scrollLeft,
  viewWidth,
}: Params): number | undefined {
  const visible =
    chipLeft >= scrollLeft && chipLeft + chipWidth <= scrollLeft + viewWidth
  if (visible) return undefined
  return Math.max(0, chipLeft - viewWidth / 2 + chipWidth / 2)
}
